import TableCell from '@mui/material/TableCell'
import { styled } from '@mui/material/styles'

const StyledTableCell = styled(TableCell)(({ dark, theme }) => ({
  '&.MuiTableCell-head': {
    backgroundColor: dark ? theme.palette.grey[200] : 'inherit',
    fontSize: 16
  },
  '&.MuiTableCell-body': {
    backgroundColor: dark ? theme.palette.grey[200] : 'inherit',
    fontSize: 16
  }
}))

export default StyledTableCell
